import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { Button } from '@instructure/ui-buttons';
import { View } from '@instructure/ui-view';
import { API_INPUT_VALIDATION_ERROR } from '@instructure/quiz-common';
import t from '@instructure/quiz-i18n/format-message';
import noop from '../../../../util/noop';
export var EntrySave = /*#__PURE__*/function (_Component) {
  function EntrySave() {
    var _this2;
    _classCallCheck(this, EntrySave);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, EntrySave, [].concat(args));
    _defineProperty(_this2, "state", {
      canSubmit: true
    });
    _defineProperty(_this2, "createScreenReaderNotification", function () {
      var displayPosition = _this2.props.displayPosition;
      var msg = displayPosition === null ? t('This question cannot be saved due to invalid input data.') : t('Question {displayPosition} cannot be saved due to invalid input data.', {
        displayPosition: displayPosition
      });
      _this2.props.screenreaderNotification(msg);
    });
    _defineProperty(_this2, "onSubmit", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();
              if (!_this2.props.isValid) {
                _context.next = 5;
                break;
              }
              _this2.successfulSubmit();
              _context.next = 10;
              break;
            case 5:
              _this2.createScreenReaderNotification();
              _context.next = 8;
              return _this2.props.showError(_this2.props.guid);
            case 8:
              _this2.props.clearNextQuizEntry();
              _this2.focusFirstErrorField();
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(_this2, "focusFirstErrorField", function () {
      var itemEditArea = _this2.props.itemEditArea;
      if (itemEditArea) {
        var editArea = ReactDOM.findDOMNode(itemEditArea);
        var firstErrorField = editArea === null || editArea === void 0 ? void 0 : editArea.querySelector('[aria-invalid="true"]');
        firstErrorField && firstErrorField.focus();
      }
    });
    _defineProperty(_this2, "clearChanges", function () {
      var fromCancel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      _this2.props.switchOffEditing();
      _this2.props.hideError(_this2.props.guid);
      _this2.props.clearChanges(fromCancel);
    });
    _defineProperty(_this2, "onCancel", function () {
      _this2.clearChanges(true);
      _this2.props.cancelHandler();
    });
    return _this2;
  }
  _inherits(EntrySave, _Component);
  return _createClass(EntrySave, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this.props.switchOnEditing(this.props.initialFocusId);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearChanges();
      var msg = t('Question editing mode turned off.');
      this.props.screenreaderNotification(msg);
    }
  }, {
    key: "successfulSubmit",
    value: function () {
      var _successfulSubmit = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var validationResult;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.setState({
                canSubmit: false
              });
              _context2.prev = 1;
              _context2.next = 4;
              return this.props.submitHandler();
            case 4:
              validationResult = _context2.sent;
              if (!(validationResult === API_INPUT_VALIDATION_ERROR)) {
                _context2.next = 8;
                break;
              }
              this.createScreenReaderNotification();
              throw new Error('User input validation error received from API.');
            case 8:
              _context2.next = 14;
              break;
            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](1);
              this.setState({
                canSubmit: true
              });
              return _context2.abrupt("return");
            case 14:
              this.props.switchOffEditing();
              this.props.hideError(this.props.guid);
              this.props.screenreaderNotification(t('Changes to question saved.'));
            case 17:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[1, 10]]);
      }));
      function successfulSubmit() {
        return _successfulSubmit.apply(this, arguments);
      }
      return successfulSubmit;
    }()
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(View, {
        as: "div",
        display: "flex"
      }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Button, {
        type: "button",
        onClick: this.onCancel,
        "data-automation": "sdk-cancel-button"
      }, t('Cancel'))), /*#__PURE__*/React.createElement(View, {
        margin: "none none none x-small"
      }, /*#__PURE__*/React.createElement(Button, {
        type: "button",
        color: "primary",
        onClick: this.onSubmit,
        disabled: !this.state.canSubmit || this.props.disableSubmit,
        "data-automation": "sdk-done-button"
      }, t('Done'))));
    }
  }]);
}(Component);
_defineProperty(EntrySave, "propTypes", {
  cancelHandler: PropTypes.func,
  clearChanges: PropTypes.func.isRequired,
  // From connected component
  clearNextQuizEntry: PropTypes.func.isRequired,
  disableSubmit: PropTypes.bool,
  displayPosition: PropTypes.number,
  guid: PropTypes.string,
  hideError: PropTypes.func.isRequired,
  initialFocusId: PropTypes.string,
  isValid: PropTypes.bool.isRequired,
  itemEditArea: PropTypes.object,
  showError: PropTypes.func.isRequired,
  screenreaderNotification: PropTypes.func.isRequired,
  submitHandler: PropTypes.func.isRequired,
  // from makescrollable / from props being passed in occasionally
  switchOnEditing: PropTypes.func.isRequired,
  switchOffEditing: PropTypes.func.isRequired
});
_defineProperty(EntrySave, "defaultProps", {
  cancelHandler: noop,
  disableSubmit: false,
  displayPosition: null,
  guid: null,
  initialFocusId: null,
  itemEditArea: null
});
export default EntrySave;